module.exports = __webpack_public_path__ + "static/media/fireeye.70d68aeb.png";